import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { RegistrationDataProvider } from "./store/RegistrationStore";
import { LoginDataProvider } from "./store/LoginStore";
import { StatusModalProvider } from "./context/StatusModalContext";
import StatusModal from "./Components/StatusModal";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { ToastProvider } from "./store/ToastProvider/ToastProvider";

if (
  process.env.NODE_ENV === "production" &&
  window.origin === "https://www.app.skedy.life"
) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("root");

  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_ID}>
        <PostHogProvider client={posthog}>
          <BrowserRouter>
            <StatusModalProvider>
              <RegistrationDataProvider>
                <LoginDataProvider>
                  <ToastProvider>
                    <App />
                    <StatusModal />
                  </ToastProvider>
                </LoginDataProvider>
              </RegistrationDataProvider>
            </StatusModalProvider>
          </BrowserRouter>
        </PostHogProvider>
      </GoogleOAuthProvider>,
    );
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload();
      });
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
